/**
 * Utility functions for financial year calculations
 */

/**
 * Generates year options based on current date and financial year logic
 * @returns {Array} Array of year options with value and label properties
 */
export const getYearOptions = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0-indexed: 0 = January, 2 = March

    // Financial year in India: April to March
    // If current month is Jan (0), Feb (1), or Mar (2): FY is previous year to current year
    // If current month is Apr (3) to Dec (11): FY is current year to next year
    let currentFYStart, currentFYEnd;

    if (month <= 2) { // January, February, March
        currentFYStart = year - 1;
        currentFYEnd = year;
    } else { // April to December
        currentFYStart = year;
        currentFYEnd = year + 1;
    }

    const currentFY = `${currentFYStart}-${currentFYEnd}`;
    const nextFY = `${currentFYEnd}-${currentFYEnd + 1}`;

    // If current month is March, provide both current FY and next FY
    if (month === 2) { // March
        return [
            { value: currentFY, label: currentFY },
            { value: nextFY, label: nextFY }
        ];
    } else {
        // For all other months, provide only current FY
        return [
            { value: currentFY, label: currentFY }
        ];
    }
};

/**
 * Gets the current financial year string
 * @returns {string} Current FY in format "YYYY-YYYY"
 */
export const getCurrentFinancialYear = () => {
    const options = getYearOptions();
    return options[0].value; // First option is always current FY
};

/**
 * Checks if current date is within March (transition period)
 * @returns {boolean} True if current month is March
 */
export const isTransitionPeriod = () => {
    const now = new Date();
    return now.getMonth() === 2; // March
};

/**
 * Checks if a given year string represents the current financial year
 * @param {string} yearString - Year in format "YYYY-YYYY"
 * @returns {boolean} True if it matches current FY
 */
export const isCurrentFinancialYear = (yearString) => {
    return yearString === getCurrentFinancialYear();
};